import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"
import { authApi } from '../auth';

export const taskPlanApiV2 = createApi({
    reducerPath: 'taskPlanApiV2',
    baseQuery: axiosBaseQuery({
        baseUrl: "/task_plans",
    }),
    tagTypes: ["TaskPlan"],
    endpoints: (builder) => ({
        getTaskPlanData: builder.query({
            query: ({ page = 1, limit = 10, status = "", school = "", search = "", sort = { column: "id", direction: "DESC" } }) => ({
                method: "PATCH",
                url: `/list`,
                data: { page, limit, sort, search, status: status?.value, school: school?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlan"]
        }), 
        ViewTaskPlan: builder.query({
            query: ({ id }) => ({
                method: "GET",
                url: `/view/${id}`
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlan"]
        }),

        createTaskPlan: builder.mutation({
            query: (values) => ({
                method: "POST",
                url: `/create`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),

        updateTaskPlan: builder.mutation({
            query: ({ values, id }) => ({
                method: "PUT",
                url: `/update/${id}`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),
        updateSingleTask: builder.mutation({
            query: ({ values, id }) => ({
                method: "PUT",
                url: `/task/update/${id}`,
                data: values
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),

        favouriteTaskPlan: builder.mutation({
            query: ({ data, id }) => ({
                method: "POST",
                url: `/favorite/${id}`,
                data: data
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),

        favouriteTaskPlanClient: builder.mutation({
            query: ({ data, id,clientId }) => ({
                method: "POST",
                url: `/favorite/${id}/${clientId}`,
                data: data
            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),


        getTaskPlanSchoolClients: builder.query({
            query: () => ({
                method: "GET",
                url: `/school/clients`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlan"]
        }),

        updateTaskStatus: builder.mutation({
            query: ({ payload, id }) => ({
                method: "PUT",
                url: `/status/${id}`,
                data: payload
            }),
            transformResponse: (response) => {
                return response.data;
            },
            invalidatesTags: ["TaskPlan"]
        }),

        getTaskSessionsData: builder.query({
            query: ({ taskPlanId, taskId, clientId }) => ({
                method: "GET",
                url: `/sessions/list/${taskPlanId}/${taskId}/${clientId}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["TaskPlan"]
        }),

        createTaskSessions: builder.mutation({
            query: ({ payload, taskPlanId, taskId, clientId }) => ({
                method: "POST",
                url: `/sessions/create/${taskPlanId}/${taskId}/${clientId}`,
                data: payload

            }),
            transformResponse: (response) => {
                return response;
            },
            invalidatesTags: ["TaskPlan"]
        }),

    }),
})

export const {
    useCreateTaskPlanMutation,
    useGetTaskPlanDataQuery, 
    useUpdateTaskPlanMutation,
    useFavouriteTaskPlanMutation,
    useGetTaskPlanSchoolClientsQuery,
    useViewTaskPlanQuery,
    useUpdateTaskStatusMutation,
    useUpdateSingleTaskMutation,
    useGetTaskSessionsDataQuery,
    useCreateTaskSessionsMutation,
    useFavouriteTaskPlanClientMutation
} = taskPlanApiV2;